import fetch from '@/api'

export function getPersonList(params) {
    return fetch({
        method: 'get',
        url:  `/persons`,
        params,
    })
}

// 根据id查详情
export function getPerson(id) {
    return fetch({
        method: 'get',
        url:  `/persons/${id}`
    })
}

// 根据name查详情
export function getPersonName(userName) {
    return fetch({
        method: 'get',
        url:  `/persons/account/${userName}`
    })
}


export function addPerson(data) {
    return fetch({
        method: 'post',
        url:  '/persons',
        data,
    })
}

export function updatePerson(id, data) {
    return fetch({
        method: 'put',
        url:  `/persons/${id}`,
        data,
    })
}

export function deletePerson(id) {
    return fetch({
        method: 'delete',
        url:  `/persons/${id}`,
    })
}

// 注销或启用
export function changePersonStatus(id) {
    return fetch({
        method: 'post',
        url:  `/persons/${id}/status`,
    })
}

//重置密码

export function resetPersonPassword(id) {
    return fetch({
        method: 'post',
        url:  `/persons/${id}/resetPassword`,
    })
}

//登录查询 lTT
export function LoginInfo(params) {
    return fetch({
        method: 'get',
        url:  `/terminalBind`,
        params
    })
}
//134.后台监控-查询用户列表
export function getUserList(params) {
    return fetch({
        method: 'get',
        url:  `/truck_user_info/get_user_list`,
        params
    })
}
//134.后台监控-查询用户列表
export function getCustomerList(params) {
    return fetch({
        method: 'get',
        url:  `/truck_user_info/get_customer_list`,
        params
    })
}
//134.后台监控-查询用户列表
export function setDoUser(data) {
    return fetch({
        method: 'post',
        url:  `/truck_user_info/do_user`,
        data
    })
}

//43.添加培训记录
export function setLinkhis() {
    return fetch({
        method: 'post',
        url:  `/linkhis/add`
    })
}
//44.浏览培训记录
export function getLinkhis(params) {
    return fetch({
        method: 'get',
        url:  `/linkhis/get_linkhis`,
        params
    })
}
// 消息管理列表
export function getMessage(params) {
    return fetch({
        method: 'get',
        url:  `/message`,
        params
    })
}
// 消息读取情况
export function findRecipientState(params) {
    return fetch({
        method: 'get',
        url:  `/message/findRecipientState`,
        params
    })
}
// 发消息
export function sendMessage(data) {
    return fetch({
        method: 'post',
        url:  `/message/sendMessage`,
        data
    })
}
// 滚动消息
export function getRollMessage(params) {
    return fetch({
        method: 'get',
        url:  `/message/rollMessage`,
        params
    })
}
// 站内信
export function getReceiveMessage(params) {
    return fetch({
        method: 'get',
        url:  `/message/findReceive`,
        params
    })
}
// 标为已读
export function setBatchRead(data) {
    return fetch({
        method: 'post',
        url:  `/message/batchRead`,
        data
    })
}
// 收件人列表
export function getFindRecipient(params) {
    return fetch({
        method: 'get',
        url:  `/message/findRecipient`,
        params
    })
}
//绑定usbkey
export function setBindKey(userId,sn) {
    return fetch({
        method: 'post',
        url:  `/truck_user_info/bind_key/${userId}/${sn}`
    })
}
//解绑usbkey
export function setUnbindKey(userId) {
    return fetch({
        method: 'post',
        url:  `/truck_user_info/unbind_key/${userId}`
    })
}
//启用禁用usbkey
export function setEnableDisableKey(userId,dotype) {
    return fetch({
        method: 'post',
        url:  `/truck_user_info/enable_disable_key/${userId}/${dotype}`
    })
}
// usbkey列表
export function getUsbkeyList(params) {
    return fetch({
        method: 'get',
        url:  `/truck_user_info/get_usbkey_list`,
        params
    })
}
// usbkey列表
export function setUnbindTel(userId) {
    return fetch({
        method: 'post',
        url:   `/truck_user_info/unbind_serial/${userId}`
    })
}


// WEBPACK FOOTER //
// ./src/api/system/person.js